module.exports = __webpack_public_path__ + "static/img/lk2.f437360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/lk2.jpg
// module id = xs/X
// module chunks = 2